/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Dd_Exp_LabelInputs */

const es_nav_dd_exp_label = /** @type {(inputs: Nav_Dd_Exp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const gl_nav_dd_exp_label = /** @type {(inputs: Nav_Dd_Exp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const en_nav_dd_exp_label = /** @type {(inputs: Nav_Dd_Exp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiences`)
};

/**
* | output |
* | --- |
* | "Zarpar Experiences" |
*
* @param {Nav_Dd_Exp_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_dd_exp_label = /** @type {((inputs?: Nav_Dd_Exp_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dd_Exp_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_dd_exp_label(inputs)
	if (locale === "en") return en_nav_dd_exp_label(inputs)
	return es_nav_dd_exp_label(inputs)
});